import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Toaster } from 'react-hot-toast'
import { useTheme } from '@mui/material/styles'

import ReactHotToast from 'src/@core/styles/libs/react-hot-toast'
import { useSettings } from 'src/@core/hooks/useSettings'

/**
 * Mounts react-hot-toast at `document.body` so fixed stacking is not trapped under
 * layout stacking contexts (BHYBE rail uses `zIndex.drawer`). Position is forced to
 * top-right so persisted theme settings cannot send errors behind the sidebar.
 */
export const GlobalToaster: React.FC = () => {
  const theme = useTheme()
  const { settings } = useSettings()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <ReactHotToast ownerState={{ layout: settings.layout, navHidden: settings.navHidden }}>
      <Toaster
        position='top-right'
        toastOptions={{ className: 'react-hot-toast' }}
        containerStyle={{
          zIndex: theme.zIndex.tooltip + 500
        }}
      />
    </ReactHotToast>,
    document.body
  )
}
